// import axios from 'axios'
import { post, put, get } from '@/api/api'

export const actions = {
  fetchFilms ({ commit}) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/films`)
      .then(({ data }) => {
        commit('addFilms', data)
      })
  },
  async fetchFilmsPage({ commit }, params = {}) {
    const { page = 0, size = 10, sort = '', title = '', shortName = '', siteId = ''} = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort,
      ...(title && { title }),
      ...(shortName && { shortName }),
      ...(siteId && { siteId }),
    }).toString();

    let { data } = await get(`/canal/films/page?${queryParams}`);
    commit("addfilmsPage", data)
    return data;
  },
  createFilm ({ commit }, film) {
    return post('/canal/films', film)
      .then(({ data }) => {
        commit('addFilm', data)
      })
  },
  updateFilm ({ commit }, film) {
    return put(`/canal/films/${film.id}`, film)
      .then(({ data }) => {
        commit('replaceFilm', data)
      })
  },
  createOrUpdateFilm ({ dispatch }, film) {
    if (film.id !== undefined) {
      return dispatch('updateFilm', film)
    } else {
      return dispatch('createFilm', film)
    }
  },
  selectFilm ({ commit }, film) {
    commit('setFilm', film)
  }
}
